import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useIAChatFloatingButtonStyles = makeStyles(() => ({
  fab: {
    position: 'fixed',
    bottom: 32,
    right: 32,
    width: 64,
    height: 64,
    backgroundColor: colors.primary,
    color: colors.white,
    boxShadow: '0px 8px 24px rgba(0, 10, 141, 0.4)',
    zIndex: 1200,
    '&:hover': {
      backgroundColor: colors.primaryDark,
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      bottom: 24,
      right: 24,
      width: 56,
      height: 56,
    },
  },
  fabIcon: {
    width: 66,
    height: 66,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: 58,
      height: 58,
    },
  },
  tooltipContent: {
    width: '100%',
    textAlign: 'center',
  },
  tooltipTitle: {
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    lineHeight: 'normal',
    textAlign: 'center',
    marginBottom: spacing.xs,
  },
  tooltipSubtitle: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    lineHeight: '14px',
    textAlign: 'center',
  },
}));
